import { langList } from '@/localisation/i18n';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export const Language = () => {
  const navigate = useNavigate();
  const { i18n } = useTranslation();

  const changeLang = (e: React.ChangeEvent<HTMLSelectElement>) => {
    i18n.changeLanguage(e.target.value);

    localStorage.setItem('lang', e.target.value);

    navigate(0);
  };

  return (
    <>
      <div className="my-3 md:my-5">
        <div className="text-additional text-base">{i18n.t('language')}</div>
        <select
          onChange={changeLang}
          className="select select-bordered bg-card mt-5 w-[380px] max-w-xs"
        >
          {langList.map(({ code, name }) => (
            <option key={code} value={code} selected={code === i18n.language}>
              {name}
            </option>
          ))}
        </select>
      </div>
      <div className="divider"></div>
    </>
  );
};
